import React from 'react';
import Icon from './Icon';

const CheckAlt = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <title>CheckAlt</title>
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
  </Icon>
);

export default CheckAlt;
